<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('LineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: this.getIcon('line'),
                type: 'Segment',
                name: 'Trend Line',
                hint: 'Draw a Trend Line',
                data: [],     // Default data
                settings: {}, // Default settings
                // Modifications
                mods: {
                    'Extended': {
                        // Rewrites the default setting fields
                        settings: { extended: true },
                        category: 'Lines',
                        icon: this.getIcon('extended'),
                        hint: 'Draw an Extended Trend Line',
                        name: 'Extended Line'
                    },
                    'Ray': {
                        // Rewrites the default setting fields
                        settings: { ray: true },
                        category: 'Lines',
                        icon: this.getIcon('ray'),
                        hint: 'Draw a Ray Line',
                        name: 'Ray'
                    },
                    'Arrow': {
                        // Rewrites the default setting fields
                        settings: { arrow: true },
                        category: 'Lines',
                        icon: this.getIcon('arrow'),
                        hint: 'Draw an Arrow Line',
                        name: 'Arrow'
                    }
                }
            }
        }, s => s.ray ? 'Ray' : s.extended ? 'Extended Line' : s.arrow ? 'Arrow' : 'Trend Line')
</script>
